/**
 * Action creator for modal visibility.
 * Translation: Action creator for modal visibility.
 *
 * @param {boolean} isOpen - Modal open state.
 * @returns {{type: string, payload: boolean}} Reducer action.
 */
export const isModalOpen = (isOpen) => {
  console.log("[AUDIT] - isModalOpen:", isOpen);
  return {
    type: "IS_MODAL_OPEN",
    payload: isOpen,
  };
};

/**
 * Action creator for body overflow control.
 * Translation: Action creator for body overflow control.
 *
 * @param {string} overflow - CSS overflow value.
 * @returns {{type: string, payload: string}} Reducer action.
 */
export const setBodyOverflow = (overflow) => {
  console.log("[AUDIT] - setBodyOverflow:", overflow);
  return {
    type: "SET_BODY_OVERFLOW",
    payload: overflow,
  };
};

/**
 * Action creator for mobile menu state.
 * Translation: Action creator for mobile menu state.
 *
 * @param {boolean} isOpen - Requested open state.
 * @returns {{type: string, payload: boolean}} Reducer action.
 */
export const setMobileMenuOpen = (isOpen) => {
  console.log("[AUDIT] - setMobileMenuOpen:", isOpen);
  return {
    type: "SET_MOBILE_MENU_OPEN",
    payload: isOpen,
  };
};

/**
 * Action creator for active section tracking.
 * Translation: Action creator for active section tracking.
 *
 * @param {string|null} sectionId - Current visible section id.
 * @returns {{type: string, payload: string|null}} Reducer action.
 */
export const setActiveSection = (sectionId) => {
  console.log("[AUDIT] - setActiveSection:", sectionId);
  return {
    type: "SET_ACTIVE_SECTION",
    payload: sectionId,
  };
};

/**
 * Action creator for reduced motion preference.
 * Translation: Action creator for reduced motion preference.
 *
 * @param {boolean} prefersReducedMotion - Browser accessibility preference.
 * @returns {{type: string, payload: boolean}} Reducer action.
 */
export const setPrefersReducedMotion = (prefersReducedMotion) => {
  console.log("[AUDIT] - setPrefersReducedMotion:", prefersReducedMotion);
  return {
    type: "SET_PREFERS_REDUCED_MOTION",
    payload: prefersReducedMotion,
  };
};

/**
 * Action creator for current page metadata.
 * Translation: Action creator for current page metadata.
 *
 * @param {Object} metadata - Current SEO metadata payload.
 * @returns {{type: string, payload: Object}} Reducer action.
 */
export const setPageMetadata = (metadata) => {
  console.log("[AUDIT] - setPageMetadata:", metadata?.title || "unknown");
  return {
    type: "SET_PAGE_METADATA",
    payload: metadata,
  };
};

/**
 * Action creator for manifest-only PWA mode.
 * Translation: Action creator for manifest-only PWA mode.
 *
 * @param {string} mode - Current PWA mode flag.
 * @returns {{type: string, payload: string}} Reducer action.
 */
export const setPwaMode = (mode) => {
  console.log("[AUDIT] - setPwaMode:", mode);
  return {
    type: "SET_PWA_MODE",
    payload: mode,
  };
};
